export default {
  lineNumberColor: `#fff`,
  lineNumberBgColor: `#222`,
  backgroundColor: `#222`,
  textColor: `#fff`,
  substringColor: `#fff`,
  keywordColor: `#8f9c6c`,
  attributeColor: `#9b869b`,
  selectorTagColor: `#8f9c6c`,
  docTagColor: `#fff`,
  nameColor: `#9b869b`,
  builtInColor: `#ab875d`,
  literalColor: `#ab875d`,
  bulletColor: `#ab875d`,
  codeColor: `#fff`,
  additionColor: `#8f9c6c`,
  regexpColor: `#ab875d`,
  symbolColor: `#ab875d`,
  variableColor: `#ab875d`,
  templateVariableColor: `#ab875d`,
  linkColor: `#ab875d`,
  selectorAttributeColor: `#fff`,
  selectorPseudoColor: `#ff`,
  typeColor: `#9b869b`,
  stringColor: `#8f9c6c`,
  selectorIdColor: `#9b869b`,
  selectorClassColor: `#9b869b`,
  quoteColor: `#777`,
  templateTagColor: `#ab875d`,
  deletionColor: `#ab875d`,
  titleColor: `#9b869b`,
  sectionColor: `#9b869b`,
  commentColor: `#777`,
  metaKeywordColor: `#ab875d`,
  metaColor: `#ab875d`,
  functionColor: `#fff`,
  numberColor: `#ab875d`,
}
